import { MatchValueType, Version } from "../../model/model"
import ObjectUtil from "../../util/ObjectUtil"
import TypeUtil from "../../util/TypeUtil"
import UrlUtil from "../../util/UrlUtil"

export default interface ValueMatcher {
  inMatches(userValue: any, matchValue: any): boolean
  containsMatches(userValue: any, matchValue: any): boolean
  startsWithMatches(userValue: any, matchValue: any): boolean
  endsWithMatches(userValue: any, matchValue: any): boolean
  greaterThanMatches(userValue: any, matchValue: any): boolean
  greaterThanOrEqualMatches(userValue: any, matchValue: any): boolean
  lessThanMatches(userValue: any, matchValue: any): boolean
  lessThanOrEqualMatches(userValue: any, matchValue: any): boolean
}

export class StringMatcher implements ValueMatcher {
  inMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asString(userValue)
    const typedMatchValue = TypeUtil.asString(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue === typedMatchValue
  }

  containsMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asString(userValue)
    const typedMatchValue = TypeUtil.asString(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue.includes(typedMatchValue)
  }

  startsWithMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asString(userValue)
    const typedMatchValue = TypeUtil.asString(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue.startsWith(typedMatchValue)
  }

  endsWithMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asString(userValue)
    const typedMatchValue = TypeUtil.asString(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue.endsWith(typedMatchValue)
  }

  greaterThanMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asString(userValue)
    const typedMatchValue = TypeUtil.asString(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue > typedMatchValue
  }

  greaterThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asString(userValue)
    const typedMatchValue = TypeUtil.asString(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue >= typedMatchValue
  }

  lessThanMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asString(userValue)
    const typedMatchValue = TypeUtil.asString(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue < typedMatchValue
  }

  lessThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asString(userValue)
    const typedMatchValue = TypeUtil.asString(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue <= typedMatchValue
  }
}

export class NumberMatcher implements ValueMatcher {
  inMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asNumber(userValue)
    const typedMatchValue = TypeUtil.asNumber(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue === typedMatchValue
  }

  containsMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  startsWithMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  endsWithMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  greaterThanMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asNumber(userValue)
    const typedMatchValue = TypeUtil.asNumber(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue > typedMatchValue
  }

  greaterThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asNumber(userValue)
    const typedMatchValue = TypeUtil.asNumber(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue >= typedMatchValue
  }

  lessThanMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asNumber(userValue)
    const typedMatchValue = TypeUtil.asNumber(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue < typedMatchValue
  }

  lessThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asNumber(userValue)
    const typedMatchValue = TypeUtil.asNumber(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue <= typedMatchValue
  }
}

export class BooleanMatcher implements ValueMatcher {
  inMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = TypeUtil.asBoolean(userValue)
    const typedMatchValue = TypeUtil.asBoolean(matchValue)

    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    return typedUserValue === typedMatchValue
  }

  containsMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  startsWithMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  endsWithMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  greaterThanMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  greaterThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  lessThanMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  lessThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    return false
  }
}

export class VersionMatcher implements ValueMatcher {
  inMatches(userValue: any, matchValue: any): boolean {
    const userVersion = Version.tryParse(userValue)
    const matchVersion = Version.tryParse(matchValue)
    if (ObjectUtil.isNullOrUndefined(userVersion) || ObjectUtil.isNullOrUndefined(matchVersion)) {
      return false
    }
    return userVersion.isEqualTo(matchVersion)
  }

  containsMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  startsWithMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  endsWithMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  greaterThanMatches(userValue: any, matchValue: any): boolean {
    const userVersion = Version.tryParse(userValue)
    const matchVersion = Version.tryParse(matchValue)
    if (ObjectUtil.isNullOrUndefined(userVersion) || ObjectUtil.isNullOrUndefined(matchVersion)) {
      return false
    }
    return userVersion.isGreaterThan(matchVersion)
  }

  greaterThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    const userVersion = Version.tryParse(userValue)
    const matchVersion = Version.tryParse(matchValue)
    if (ObjectUtil.isNullOrUndefined(userVersion) || ObjectUtil.isNullOrUndefined(matchVersion)) {
      return false
    }
    return userVersion.isGreaterThanOrEqualTo(matchVersion)
  }

  lessThanMatches(userValue: any, matchValue: any): boolean {
    const userVersion = Version.tryParse(userValue)
    const matchVersion = Version.tryParse(matchValue)
    if (ObjectUtil.isNullOrUndefined(userVersion) || ObjectUtil.isNullOrUndefined(matchVersion)) {
      return false
    }
    return userVersion.isLessThan(matchVersion)
  }

  lessThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    const userVersion = Version.tryParse(userValue)
    const matchVersion = Version.tryParse(matchValue)
    if (ObjectUtil.isNullOrUndefined(userVersion) || ObjectUtil.isNullOrUndefined(matchVersion)) {
      return false
    }
    return userVersion.isLessThanOrEqualTo(matchVersion)
  }
}

export class UrlMatcher implements ValueMatcher {
  inMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = UrlUtil.tryParse(userValue)
    const typedMatchValue = TypeUtil.asString(matchValue)

    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    const decodedUserValue = UrlUtil.decodeURIOrOriginal(UrlUtil.removePathnameTrailingSlash(typedUserValue))
    const decodedMatchValue = UrlUtil.decodeURIOrOriginal(UrlUtil.removePathnameTrailingSlash(typedMatchValue))

    return decodedUserValue === decodedMatchValue
  }

  containsMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = UrlUtil.tryParse(userValue)
    const typedMatchValue = TypeUtil.asString(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    const decodedUserValue = UrlUtil.decodeURIOrOriginal(typedUserValue.href)
    return decodedUserValue.includes(typedMatchValue) || decodedUserValue.includes(encodeURI(typedMatchValue))
  }

  startsWithMatches(userValue: any, matchValue: any): boolean {
    const typedUserValue = UrlUtil.tryParse(userValue)
    const typedMatchValue = TypeUtil.asString(matchValue)
    if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
      return false
    }
    const decodedUserValue = UrlUtil.decodeURIOrOriginal(typedUserValue.href)
    return decodedUserValue.startsWith(typedMatchValue) || decodedUserValue.startsWith(encodeURI(typedMatchValue))
  }

  endsWithMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  greaterThanMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  greaterThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  lessThanMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  lessThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    return false
  }
}

export class NullMatcher implements ValueMatcher {
  inMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  containsMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  startsWithMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  endsWithMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  greaterThanMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  greaterThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  lessThanMatches(userValue: any, matchValue: any): boolean {
    return false
  }

  lessThanOrEqualMatches(userValue: any, matchValue: any): boolean {
    return false
  }
}

export class ValueMatcherFactory {
  private static STRING_MATCHER = new StringMatcher()
  private static NUMBER_MATCHER = new NumberMatcher()
  private static BOOLEAN_MATCHER = new BooleanMatcher()
  private static VERSION_MATCHER = new VersionMatcher()
  private static URL_MATCHER = new UrlMatcher()
  private static NULL_MATCHER = new NullMatcher()

  getMatcher(valueType: MatchValueType): ValueMatcher {
    switch (valueType) {
      case "STRING":
        return ValueMatcherFactory.STRING_MATCHER
      case "JSON":
        return ValueMatcherFactory.STRING_MATCHER
      case "NUMBER":
        return ValueMatcherFactory.NUMBER_MATCHER
      case "BOOLEAN":
        return ValueMatcherFactory.BOOLEAN_MATCHER
      case "VERSION":
        return ValueMatcherFactory.VERSION_MATCHER
      case "URL":
        return ValueMatcherFactory.URL_MATCHER
      case "NULL":
        return ValueMatcherFactory.NULL_MATCHER
      case "UNKNOWN":
        return ValueMatcherFactory.NULL_MATCHER
    }
  }
}
